// アプリ全体で使う Tailwind クラス文字列の定義。
// ダークモードは Tailwind の dark: バリアント（tailwind.config.js の darkMode: "class"）で表現する。

// ヘッダー背景のドットパターン（60x60 SVG、light は黒 / dark は白の fill）
const headerPatternLight =
	"bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMwMDAwMDAiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNC0xLjggNC00IDQtNC0xLjgtNC00eiIvPjxwYXRoIGQ9Ik0xNiAxNmMyLjIgMCA0LTEuOCA0LTRzLTEuOC00LTQtNC00IDEuOC00IDQgMS44IDQgNCA0em0wIDJjLTMuMyAwLTYtMi43LTYtNnMyLjctNiA2LTYgNiAyLjcgNiA2LTIuNyA2LTYgNnptMjQgMjRjMS4yIDAgMi0uOCA2LTJzLS44LTItMi0yLTIgLjgtMiAyIC44IDIgMiAyem0wIDJjLTIuMiAwLTQtMS44LTQtNHMxLjgtNCA0LTQgNCAxLjggNCA0LTEuOCA0LTQgNHptLTI0IDBjLTMuMyAwLTYtMi43LTYtNnMyLjctNiA2LTYgNiAyLjcgNiA2LTIuNyA2LTYgNnptMC0yYzIuMiAwIDQtMS44IDQtNHMtMS44LTQtNC00LTQgMS44LTQgNCAxLjggNCA0IDR6TS0xMCAzMGMwIDUuNSA0LjUgMTAgMTAgMTBzMTAtNC41IDEwLTEwUzUuNSAyMCAwIDIwcy0xMCA0LjUtMTAgMTB6bTkgMGMwLTUuNSA0LjUtMTAgMTAtMTBzMTAgNC41IDEwIDEwLTQuNSAxMC0xMCAxMC0xMC00LjUtMTAtMTB6Ii8+PC9nPjwvZz48L3N2Zz4=')]";
const headerPatternDark =
	"dark:bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIgMS44LTQgNC00czQgMS44IDQgNC0xLjggNC00IDQtNC0xLjgtNC00eiIvPjxwYXRoIGQ9Ik0xNiAxNmMyLjIgMCA0LTEuOCA0LTRzLTEuOC00LTQtNC00IDEuOC00IDQgMS44IDQgNCA0em0wIDJjLTMuMyAwLTYtMi43LTYtNnMyLjctNiA2LTYgNiAyLjcgNiA2LTIuNyA2LTYgNnptMjQgMjRjMS4yIDAgMi0uOCA2LTJzLS44LTItMi0yLTIgLjgtMiAyIC44IDIgMiAyem0wIDJjLTIuMiAwLTQtMS44LTQtNHMxLjgtNCA0LTQgNCAxLjggNCA0LTEuOCA0LTQgNHptLTI0IDBjLTMuMyAwLTYtMi43LTYtNnMyLjctNiA2LTYgNiAyLjcgNiA2LTIuNyA2LTYgNnptMC0yYzIuMiAwIDQtMS44IDQtNHMtMS44LTQtNC00LTQgMS44LTQgNCAxLjggNCA0IDR6TS0xMCAzMGMwIDUuNSA0LjUgMTAgMTAgMTBzMTAtNC41IDEwLTEwUzUuNSAyMCAwIDIwcy0xMCA0LjUtMTAgMTB6bTkgMGMwLTUuNSA0LjUtMTAgMTAtMTBzMTAgNC41IDEwIDEwLTQuNSAxMC0xMCAxMC0xMC00LjUtMTAtMTB6Ii8+PC9nPjwvZz48L3N2Zz4=')]";

const appStyles = {
	// Header
	header: "relative py-10 text-center overflow-hidden",
	headerBackground:
		"absolute inset-0 bg-gradient-to-r from-blue-200 via-violet-200 to-purple-100 opacity-80 dark:from-blue-600 dark:via-violet-600 dark:to-purple-700",
	headerBackgroundPattern: `absolute inset-0 opacity-10 dark:opacity-20 ${headerPatternLight} ${headerPatternDark}`,
	headerContent: "relative z-10",
	title:
		"text-5xl font-extrabold tracking-tighter drop-shadow-lg mb-2 text-gray-900 dark:bg-clip-text dark:text-transparent dark:bg-gradient-to-r dark:from-white dark:to-blue-100",
	subtitle: "text-lg font-medium text-gray-700/90 dark:text-blue-100/80",

	// Recording section
	recordingSection: "flex flex-col items-center justify-center mb-6 mt-6",
	recordButton: (isRecording: boolean): string =>
		`w-28 h-28 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform ${
			isRecording
				? "bg-gradient-to-br from-red-300 to-red-500 animate-pulse shadow-red-300/30 dark:from-red-500 dark:to-red-700 dark:shadow-red-500/30"
				: "bg-gradient-to-br from-emerald-200 to-emerald-400 hover:scale-105 shadow-emerald-200/30 animate-attention dark:from-emerald-500 dark:to-emerald-700 dark:shadow-emerald-500/30"
		} cursor-pointer`,
	recordIcon: "text-5xl font-bold text-white/40 dark:text-white",

	// Layout
	controlsGrid: "grid grid-cols-1 gap-6 mt-12",

	// Card（リアルタイム文字起こし・録音履歴などの枠）
	card: "rounded-xl border shadow-md bg-white border-gray-200 text-gray-800 dark:bg-gray-900 dark:border-gray-700 dark:text-gray-100",
	cardHeader:
		"rounded-t-xl border-b px-6 py-4 bg-white border-gray-200 text-gray-800 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100",
	cardBody: "p-6 bg-white text-gray-800 dark:bg-gray-900 dark:text-gray-100",
	cardTitle: "flex items-center text-xl font-semibold text-blue-900 dark:text-blue-100",
	cardIcon: "mr-3 text-blue-700 dark:text-blue-400",

	// Form elements
	formGroup: "mb-4",
	label: "block text-sm font-medium text-gray-700 mb-2 dark:text-gray-300",
	select:
		"w-full bg-white/90 text-gray-900 border border-gray-300 rounded-lg py-2.5 px-4 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent dark:bg-gray-900/80 dark:text-white dark:border-gray-700 dark:focus:ring-blue-500",

	// Transcript display
	transcriptContainer:
		"bg-white/90 rounded-lg p-4 min-h-[150px] max-h-[300px] overflow-y-auto border border-gray-300/50 transition-all dark:bg-gray-900/80 dark:border-gray-700/50",
	transcriptEmpty: "text-gray-500 text-sm italic dark:text-gray-400",
	transcriptText: "text-sm whitespace-pre-wrap text-gray-900 font-mono dark:text-white",

	// Recording history
	recordingHistoryEmpty:
		"text-center py-10 bg-blue-50 rounded-lg border border-blue-200/80 dark:bg-gray-800/40 dark:border-gray-700/50",
	spinner: "animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-400 mx-auto dark:border-blue-500",
	recordingHistoryEmptyText: "text-blue-700 opacity-80 dark:text-gray-400 dark:opacity-100",
	recordingHistoryEmptySubText: "text-blue-500 text-sm mt-2 opacity-90 dark:text-gray-500 dark:opacity-100",
	recordingHistoryList: "space-y-2",
	recordingHistoryHeader:
		"flex flex-col md:flex-row md:items-center justify-between mb-4 pb-3 border-b border-gray-300/50 dark:border-gray-700/30",
	// 履歴内の小型アクションボタン（旧 recordingHistoryActionButton("secondary")）
	actionButtonSecondary:
		"bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm rounded px-2.5 py-1 transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed dark:bg-gray-700/50 dark:hover:bg-gray-600 dark:text-gray-200",
	recordingHistoryItemsContainer: "space-y-3 max-h-[400px] overflow-y-auto pr-1",
	recordingHistoryItem: (expanded: boolean): string =>
		`bg-gray-100 border border-gray-300/60 rounded-lg transition-all hover:bg-gray-200 shadow-sm dark:bg-gray-800/60 dark:border-gray-700/50 dark:hover:bg-gray-800/80${
			expanded ? " ring-1 ring-blue-400/50 dark:ring-blue-500/50" : ""
		}`,
	recordingHistoryItemHeader: "p-3 cursor-pointer flex items-center justify-between",
	recordingHistoryItemSelectWrapper: "flex items-center justify-center",
	recordingHistoryItemSelectBox: (selected: boolean): string =>
		`w-5 h-5 rounded border flex items-center justify-center ${
			selected
				? "bg-blue-200 border-blue-400 dark:bg-blue-600 dark:border-blue-500"
				: "bg-gray-100 border-gray-400 dark:bg-gray-800 dark:border-gray-600"
		}`,
	recordingHistoryItemSelectCheck: "text-blue-700 text-xs dark:text-white",
	recordingHistoryItemIcon: "text-blue-500 text-lg dark:text-blue-400",
	recordingHistoryItemFileName: "font-medium text-gray-900 dark:text-white",
	recordingHistoryItemMeta: "text-xs text-gray-500 dark:text-gray-400",
	recordingHistoryItemFileSize: "text-gray-500 text-xs dark:text-gray-400",
	recordingHistoryItemExpandIcon: (expanded: boolean): string =>
		`transition-transform text-gray-500 text-xs dark:text-gray-400${expanded ? " rotate-180" : ""}`,
	recordingHistoryItemDetail: "px-4 pb-5 border-t border-gray-300/30 pt-4 dark:border-gray-700/30",
	recordingHistoryAudio: "w-full mb-4",
	recordingHistoryItemDetailMetaWrapper: "mb-4 flex flex-col md:flex-row justify-between md:items-center gap-3",
	recordingHistoryItemDetailMeta: "text-xs text-gray-500 space-y-1 dark:text-gray-400",
};

export default appStyles;
